// src/components/TrainerDashboard/AthleteAdminPanel.js

import React, { useEffect, useState } from 'react';
import BackToDashboardBtn from './BackToDashboardBtn';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import '../styles/AthleteAdminPanel.css';
import API_BASE_URL from '../../config/api';

const AthleteAdminPanel = () => {
  const { t } = useTranslation();

  const [athletes, setAthletes] = useState([]);
  const [email, setEmail] = useState('');

									 
  const fetchAthletes = async () => {
    try {
      const trainerId = localStorage.getItem('userId');
      const response = await axios.get(
        `${API_BASE_URL}/api/activities/trainer/${trainerId}/athletes`
      );
      setAthletes(response.data);
    } catch (error) {
      console.error("❌ Error al obtener atletas:", error);
    }
  };

  useEffect(() => {
    fetchAthletes();
  }, []);

									  
  const handleBlock = async (athleteId, currentStatus) => {
    try {
      const newStatus = currentStatus === 'activo' ? 'bloqueado' : 'activo';

      await axios.put(`${API_BASE_URL}/api/trainers/block-athlete`, {
        athleteId,
        newStatus,
      });

      fetchAthletes();
    } catch (error) {
      console.error('❌ Error al bloquear atleta:', error);
      alert(t('athleteAdmin.changeStatusError'));
    }
  };

						
  const handleDelete = async (athleteId) => {
    if (!window.confirm(t('athleteAdmin.confirmDelete'))) return;

    try {
      await axios.delete(
        `${API_BASE_URL}/api/trainers/remove-athlete`,
        { data: { athleteId } }
      );

      fetchAthletes();
    } catch (error) {
      console.error('❌ Error al eliminar atleta:', error);
    }
  };

						   
  const handleSendInvite = async () => {
    const trainerId = localStorage.getItem('userId');
																					  

    if (!email || !trainerId) {
      alert(t('athleteAdmin.missingData'));
      return;
    }

    try {
      await axios.post(
        `${API_BASE_URL}/api/invitations/send`,
        {
          trainerId,
          athleteEmail: email,
        }
      );

      alert(t('athleteAdmin.inviteSuccess'));
      setEmail('');
    } catch (error) {
      console.error('❌ Error al enviar invitación:', error);
      alert(error.response?.data?.message || t('athleteAdmin.inviteError'));
    }
  };

  return (
    <div className="container mt-4">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>{t('athleteAdmin.title')}</h2>

        <BackToDashboardBtn />
      </div>

      {/* Invitación */}

      <div className="card p-3 mb-4">
        <h5>{t('athleteAdmin.inviteNewAthlete')}</h5>

        <div className="d-flex">
          <input
            type="email"
            className="form-control me-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('athleteAdmin.emailPlaceholder')}
          />

          <button
            className="btn btn-primary"
            onClick={handleSendInvite}
          >
            {t('athleteAdmin.sendInvite')}
          </button>
        </div>
      </div>

      {/* Tabla atletas */}

      <table className="table table-bordered">
        <thead className="thead-dark">
          <tr>
            <th>{t('athleteAdmin.name')}</th>
            <th>{t('athleteAdmin.email')}</th>
            <th>{t('athleteAdmin.status')}</th>
            <th>{t('athleteAdmin.actions')}</th>
          </tr>
        </thead>

        <tbody>
          {athletes.map((athlete) => (
            <tr key={athlete._id}>
              <td>{`${athlete.firstName} ${athlete.lastName}`}</td>
              <td>{athlete.email}</td>
              <td>{athlete.status || t('athleteAdmin.active')}</td>

              <td>
                <button
                  className={`btn btn-sm me-2 ${
                    athlete.status === 'bloqueado'
                      ? 'btn-success'
                      : 'btn-warning'
                  }`}
                  onClick={() =>
                    handleBlock(athlete._id, athlete.status)
                  }
                >
                  {athlete.status === 'bloqueado'
                    ? t('athleteAdmin.unblock')
                    : t('athleteAdmin.block')}
                </button>

                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(athlete._id)}
                >
                  {t('athleteAdmin.delete')}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
};

export default AthleteAdminPanel;
